module.exports = __webpack_public_path__ + "assets/webgl/cards.971ff604.glb";